import { Injectable } from '@angular/core';
import { StorageKeys, User } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  set(key: StorageKeys, value: string): void {
    localStorage.setItem(key, value);
  }

  getUser(): User | null {
    const user = localStorage.getItem(StorageKeys.USER);
    return user ? JSON.parse(user) : null;
  }
}
